import { render, staticRenderFns } from "./VerifiedEmail.vue?vue&type=template&id=14c92c70&scoped=true"
import script from "./VerifiedEmail.vue?vue&type=script&lang=js"
export * from "./VerifiedEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifiedEmail.vue?vue&type=style&index=0&id=14c92c70&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c92c70",
  null
  
)

export default component.exports